import { render, staticRenderFns } from "./weekAdvert.vue?vue&type=template&id=0ebb2448&scoped=true&"
import script from "./weekAdvert.vue?vue&type=script&lang=js&"
export * from "./weekAdvert.vue?vue&type=script&lang=js&"
import style0 from "./weekAdvert.vue?vue&type=style&index=0&id=0ebb2448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebb2448",
  null
  
)

export default component.exports